export default __webpack_public_path__ + "73d2c04510d153b6da5291b538422faf.woff2";